import { useMemo } from "react";

export interface UsePageTypeResult {
  isHomePage: boolean;
  isDataPage: boolean;
  isIaPage: boolean;
}

export function usePageType(location?: Location): UsePageTypeResult {
  return useMemo(() => {
    const pathname = location?.pathname || "";
    return {
      isHomePage: pathname === "/",
      isDataPage: pathname.includes("/data"),
      isIaPage: pathname.includes("/ia"),
    };
  }, [location]);
}
